export default function oneOf (array) {
  const messageArr = array.find(([condition]) => condition)
  return messageArr ? messageArr[1] : null
}
